/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MachineScheduleViewModel } from '../../models/machine-schedule-view-model';

export interface GetMachineSchedules$Params {
  workCenterId: number;
  PageIndex?: number | null;
  PageSize?: number | null;
}

export function getMachineSchedules(http: HttpClient, rootUrl: string, params: GetMachineSchedules$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MachineScheduleViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getMachineSchedules.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.query('PageIndex', params.PageIndex, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MachineScheduleViewModel>>;
    })
  );
}

getMachineSchedules.PATH = '/api/v1/MachineSchedule/{workCenterId}';
